/**
 * Dev perso Buffalo (BFLO) : envoie le ticket de préparation en PDF sur le FTP de la planche à pizza
 * à la validation d'une vente ou d'une commande, si un article correspond à la config des advanceparams de la section.
 * Indépendant du module "à préparer" et de l'impression : seule la config planche à pizza est prise en compte.
 * Import dynamique pour ne pas charger la génération PDF chez les autres entreprises ; copie des données car
 * les appelants modifient l'objet ticket juste après la validation.
 *
 * @param {string} source - 'ticket' (vente) ou 'order' (commande)
 * @param {Object} data - Ticket validé, ou commande avec son ticket rattaché
 * @param {boolean} withSupplements - true si le module suppléments est actif
 * @param {Function} t - Fonction de traduction
 * @param {Object} authParam - Contexte d'authentification (entreprise, sections)
 * @param {number} posid - Id de la section du ticket
 */
const sendBuffaloPreparation = (source,data,withSupplements,t,authParam,posid) => {
    if(authParam?.company?.dev_perso_ident!=='BFLO') return
    const section = authParam.sections?.find(value=>value.id==posid)
    // Aucun champ configuré sur la section : rien n'est envoyé à la planche à pizza
    if(!section?.advanceparams?.buffalo_preparation_custom_field) return
    const copy = JSON.parse(JSON.stringify(data))
    import('@devperso/buffalo/pos/buffaloPreparationFtp').then(module => module.default(source,copy,withSupplements,t,section.advanceparams))
}

export default sendBuffaloPreparation;
